/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type OverwatchMapTripAnnotationAudioUrlQueryVariables = Types.Exact<{
  annotationId: Types.Scalars['String']['input']
}>

export type OverwatchMapTripAnnotationAudioUrlQuery = {
  __typename?: 'Query'
  tripAnnotationAudioUrl: {
    __typename?: 'TripAnnotationAudio'
    url: string | null
    noAudioReason: Types.TripAnnotationNoAudioReason | null
  }
}

export const OverwatchMapTripAnnotationAudioUrlDocument = gql`
    query OverwatchMapTripAnnotationAudioUrl($annotationId: String!) {
  tripAnnotationAudioUrl(annotationId: $annotationId) {
    url
    noAudioReason
  }
}
    `

/**
 * __useOverwatchMapTripAnnotationAudioUrlQuery__
 *
 * To run a query within a React component, call `useOverwatchMapTripAnnotationAudioUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverwatchMapTripAnnotationAudioUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverwatchMapTripAnnotationAudioUrlQuery({
 *   variables: {
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useOverwatchMapTripAnnotationAudioUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    OverwatchMapTripAnnotationAudioUrlQuery,
    OverwatchMapTripAnnotationAudioUrlQueryVariables
  > &
    (
      | {
          variables: OverwatchMapTripAnnotationAudioUrlQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OverwatchMapTripAnnotationAudioUrlQuery,
    OverwatchMapTripAnnotationAudioUrlQueryVariables
  >(OverwatchMapTripAnnotationAudioUrlDocument, options)
}
export function useOverwatchMapTripAnnotationAudioUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OverwatchMapTripAnnotationAudioUrlQuery,
    OverwatchMapTripAnnotationAudioUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OverwatchMapTripAnnotationAudioUrlQuery,
    OverwatchMapTripAnnotationAudioUrlQueryVariables
  >(OverwatchMapTripAnnotationAudioUrlDocument, options)
}
// @ts-ignore
export function useOverwatchMapTripAnnotationAudioUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OverwatchMapTripAnnotationAudioUrlQuery,
    OverwatchMapTripAnnotationAudioUrlQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapTripAnnotationAudioUrlQuery,
  OverwatchMapTripAnnotationAudioUrlQueryVariables
>
export function useOverwatchMapTripAnnotationAudioUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapTripAnnotationAudioUrlQuery,
        OverwatchMapTripAnnotationAudioUrlQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OverwatchMapTripAnnotationAudioUrlQuery | undefined,
  OverwatchMapTripAnnotationAudioUrlQueryVariables
>
export function useOverwatchMapTripAnnotationAudioUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OverwatchMapTripAnnotationAudioUrlQuery,
        OverwatchMapTripAnnotationAudioUrlQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OverwatchMapTripAnnotationAudioUrlQuery,
    OverwatchMapTripAnnotationAudioUrlQueryVariables
  >(OverwatchMapTripAnnotationAudioUrlDocument, options)
}
export type OverwatchMapTripAnnotationAudioUrlQueryHookResult = ReturnType<
  typeof useOverwatchMapTripAnnotationAudioUrlQuery
>
export type OverwatchMapTripAnnotationAudioUrlLazyQueryHookResult = ReturnType<
  typeof useOverwatchMapTripAnnotationAudioUrlLazyQuery
>
export type OverwatchMapTripAnnotationAudioUrlSuspenseQueryHookResult =
  ReturnType<typeof useOverwatchMapTripAnnotationAudioUrlSuspenseQuery>
export type OverwatchMapTripAnnotationAudioUrlQueryResult = Apollo.QueryResult<
  OverwatchMapTripAnnotationAudioUrlQuery,
  OverwatchMapTripAnnotationAudioUrlQueryVariables
>
